import { makeStyles } from '@material-ui/core';
import { corDaSituacao, FAMILIAS } from 'utils/situacao';

const caixaDeStatus = {
  height: '32px',
  borderRadius: '5px',
  fontSize: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const contornoDaFamilia = (familia) => {
  const { texto } = corDaSituacao(familia);
  return { border: `2px solid ${texto}`, color: texto };
};

export const useStyles = makeStyles(() => ({
  status: {
    display: ' flex',
    justifyContent: 'center',
    marginTop: 20,
  },
  statusCancel: {
    ...caixaDeStatus,
    ...contornoDaFamilia(FAMILIAS.ENCERRADO),
    width: '104px',
    marginLeft: 33,
  },
  statusConfirm: {
    ...caixaDeStatus,
    ...contornoDaFamilia(FAMILIAS.CONCLUIDO),
    width: '104px',
    marginLeft: 35,
  },
  statusWaiting: {
    ...caixaDeStatus,
    ...contornoDaFamilia(FAMILIAS.PENDENTE),
    width: '132px',
    marginLeft: 43,
    marginTop: 2,
  },
}));
